import React, {Component} from 'react';
import './baby-teething.css';
import * as actions from '../Actions';
import * as teethactions from './TeethingActions';
export default function Articles({ArticlesData, eleRef}){
    // console.log(ArticlesData);
    return(
        <div>
        {ArticlesData && ArticlesData.map(articles => 
        <div key={articles.articleId} className="baby-articles" id="">
	        <div className="M16_42 article-title" onClick={()=>teethactions.ViewCountArticle(articles.articleId, articles.articleUrl)}>{articles.articleTitle}</div>
            <div className="article-img" onClick={()=>teethactions.ViewCountArticle(articles.articleId, articles.articleUrl)}>
                {eleRef.state.defaultArtImg ? 
                    <img src={require("../images/defaultTeethArticle.jpg")} /> : 
                    <img src={`${articles.articleImage}`.replace(/\.jpg$/i, ".jpg")} />
                }
            </div>
            <div className="article-txt">
                <span className="R14_61" id="">{articles.articleText}</span>
            </div>
            <span onClick={()=>teethactions.ViewCountArticle(articles.articleId, articles.articleUrl)} className="R14_link read-more">Read More</span>
            <div className="articles-social" id={`share_${articles.articleId}`}>
                <div className="views" id="">
                    <span data-icon-font="$" className="icon article-ic"></span>
                    <span className="M14_42"><span className="artviewCount">{articles.viewCount}</span> Views</span>
                </div>
                <div className="likes" >
                {articles.isLiked ? 
                    <span data-icon-font="&#xe020;" className="icon article-ic likedArticle" id={`like_${articles.articleId}`} onClick={( )=> teethactions.likeArticle(articles.articleId, 0, `like_${articles.articleId}`, articles.likeCount)}></span> : 
                    <span data-icon-font="&#xe020;" className="icon article-ic" id={`like_${articles.articleId}`} onClick={() => teethactions.likeArticle(articles.articleId, 1, `like_${articles.articleId}`, articles.likeCount)}></span> 
                }
                    <span className="M14_42"><span className="artlikeCount">{articles.likeCount}</span> Likes</span>
                </div>
                <span data-icon-font=")" className="icon right share share-icon" onClick={() => actions.shareOn(articles.articleId)}></span>
                <div className="sharing-options">
                    <ul className="">
                        <li className="whatsapp-share left" onClick={()=>actions.shareArticle('whatsapp', articles.articleUrl)}>
                        <span className="M16_61 social-share" id="whatsapp">
                            <img src={require("../images/whatsapp.png")} className="fetusfacebookimg" alt="" />
                        </span>
                        </li>
                        <li className="facebook-share left" onClick={()=>actions.shareArticle('facebook', articles.articleUrl)}>
                        <span className="M16_61 social-share" id="facebook">
                            <img src={require("../images/facebook.png")} className="facebookimg" alt="" />
                        </span>
                        </li>
                        <li className="twitter-share left" onClick={()=>actions.shareArticle('twitter', articles.articleUrl)}>
                        <span className="M16_61 social-share" id="twitter">
                            <img src={require("../images/twitter.png")} className="twitterimg"  alt="" />
                        </span>
                        </li>
                        <li className="twitter-share left" onClick={()=>actions.shareArticle('pintrest', articles.articleUrl)}>
                        <span className="M16_61 social-share" id="pintrest">
                            <img src={require("../images/pintrest.png")} className="pintrestimg" alt="" />
                        </span>
                        </li>
                    </ul>
                </div>
            </div>
            
        </div>
        )}
        </div>
    );
}



// WEBPACK FOOTER //
// src/shared/tools/baby-teething/Articles.js